module.exports = __webpack_public_path__ + "img/cog.35cdabb4.svg";